@if (mission) {
  <div class="options">
    <div>
      <button class="icon"><img src="assets/images/back-icon.svg" (click)="backToMissionConfig()"/></button>
    </div>
    <div>
      <button class="icon"><img [src]="getProductStatusIcon()" (click)="toggleProductStatus()"/></button>
    </div>
    <div>
      @if (!isProductComplete()) {
        <button class="icon"><img src="assets/images/add-button.svg" (click)="openContainerModal()"/></button>
      }
    </div>
  </div>
}

<table class="containers">
  <tr class="header">
    <th>{{ 'PRODUCT.CONTAINER' | translate }}</th>
    <th>{{ 'PRODUCT.QUANTITY' | translate }} ({{ mission.weightUom }})</th>
    <th>{{ 'PRODUCT.LOADING_STATION' | translate }}</th>
    <th>{{ 'PRODUCT.LABEL' | translate }}</th>
    <th>{{ 'CONTAINER.TRANSPORT_COMPANY' | translate }}</th>
    <th>{{ 'PRODUCT.LAST_UPDATE' | translate }}</th>
    <th></th>
  </tr>

  @for (container of containers; track container; let i = $index) {
    <tr [ngClass]="{ 'row': true, 'in-error': container.isInError }">
      <td>{{ container.containerId }}</td>
      <td>
        <div>
          @if (container.isInError) {
            <div class="tooltip">
              <img src="assets/images/warning.svg" class="warning"/>
              <span class="tooltiptext">{{ 'PRODUCT.CONTAINER_IN_WARNING' | translate | containerWarning: container }}</span>
            </div>
          }
          <input type="text"
            [ngStyle]="{'color': getContainerQuantityColor(container)}"
            [value]="container.loadedQty"
            (change)="setContainerQuantity($event, container)"
            [disabled]="isProductComplete()">
        </div>
      </td>
      <td>
        <select (change)="setContainerLoadingStation($event, container)" [disabled]="isProductComplete()">
          @for (loadingStation of loadingStations; track loadingStation) {
            <option
              [value]="loadingStation.name"
              [selected]="container.loadingstationName === loadingStation.name">
              {{ loadingStation.name }}
            </option>
          }
        </select>
      </td>
      <td>
        <select (change)="setContainerProduct($event, container)" [disabled]="isProductComplete()">
          @for (product of mission.products; track product) {
            <option
              [value]="product.productName"
              [selected]="container.productName === product.productName">
              {{ product.productName }}
            </option>
          }
        </select>
      </td>
      <td>{{ container.transportcompanyName }}</td>
      <td>{{ container.lastUpdatedOn | timestampToDate | async }} {{ container.lastUpdatedBy }}</td>
      <td>
        @if (!isProductComplete()) {
          <img
            src="assets/images/trash-icon.svg"
            (click)="removeMissionContainer(container)" class="delete"/>
        }
      </td>
    </tr>
  }
</table>

@if (mission) {
  <div class="footer">
    <div class="product">
      @for (missionProduct of mission.products; track missionProduct) {
        <div>
          <table>
            <tr>
              <th colspan="3">{{ missionProduct.productName }}</th>
            </tr>
            <tr>
              <td>{{ 'PRODUCT.LOADED_QUANTITY' | translate }}</td>
              <td>/</td>
              <td>{{ 'MISSIONS.ORDERED_QUANTITY' | translate }}</td>
            </tr>
            <tr>
              <td>
                <a [ngStyle]="{'color': getLoadedQuantityColor(missionProduct)}">{{ getLoadedQuantity(missionProduct) | number : '1.0-0' }}</a>
              </td>
              <td>/</td>
              <td>
                <a>{{ missionProduct.productmissionLoadedExpectedMassTotal | number : '1.0-0' }} {{ mission.weightUom }}</a>
                @if (!isProductComplete()) {
                  <img src="assets/images/edit-icon.svg" (click)="updateMissionProduct(missionProduct)"/>
                }
              </td>
            </tr>
          </table>
        </div>
      }
      <div>
        <a><img src="assets/images/shopping-cart.svg"/>{{ containers.length }}</a>
      </div>
    </div>
  </div>
}

@if (addingContainer) {
  <app-add-container [mission]="mission" [missionContainers]="containers" (closeModal)="closeContainerModal($event)"></app-add-container>
}
@if (updateMissionProductParams.display) {
  <app-update-mission-product [params]="updateMissionProductParams"></app-update-mission-product>
}